import {useLazyQuery, useMutation} from '@apollo/client'
import {FormEvent, useEffect, useState} from 'react'
import {Button, Form, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {EDIT_POLICY} from '../../../gql/mutations/policyMutation'
import {useDebounce} from '../../../../../_metronic/helpers'
import Select from 'react-select'
import {parseId} from '../../../helpers'
import {GET_ALL_USERS_FILTER} from '../../../gql/queries/usersQuery'
import {IResAllUsers} from '../../oneUser/oneUserTypes'
import {IResUpdatePolicyApi} from '../../../types/policies'

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
  refetch: (vars?: any) => any
  typeAssign: string
}
export const ModalAssignAgentPolicy: React.FC<IModalProps> = ({
  id,
  isOpen,
  onClose,
  refetch,
  typeAssign,
}) => {
  const [gqlGetMembers, {data: dataUsers, loading: loadingUsers}] =
    useLazyQuery<IResAllUsers, {name: string, requireNpn: boolean}>(GET_ALL_USERS_FILTER)

  const [gqlCreateP, {data: dataUpdate, loading, error: errorUpdate}] =
    useMutation<IResUpdatePolicyApi>(EDIT_POLICY)

  useEffect(() => {
    if (!dataUpdate) return

    if (dataUpdate && dataUpdate.updatePolicy.success) {
      toast.success('Status updated successfully')
      refetch({ id })
      onClose()
    } else if (dataUpdate.updatePolicy.errors && dataUpdate.updatePolicy.errors.length > 0) {
      toast.error(`Error ${dataUpdate.updatePolicy.errors[0].message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate])
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    let policyData: any

    if (typeAssign === 'ASSIGN_TO') {
      policyData = {assignedTo: agentId}
    } else {
      policyData = {user: agentId}
    }

    gqlCreateP({
      variables: {
        id: parseId(id),
        policyData,
      },
    })
  }

  useEffect(() => {
    if (errorUpdate) {
      toast.error(`Error Update Policy: ${errorUpdate.message}`)
    }
  }, [errorUpdate])

  const [agentId, setAgent] = useState<string | null>(null)
  const [inputSelect, setInputSelect] = useState('')
  const valueDeb = useDebounce(inputSelect, 500)
  const [options, setOptions] = useState<{label: string; value: string}[]>([])

  useEffect(() => {
    if (!valueDeb) {
      setOptions([])
      return
    }
    if (!dataUsers) return
    setOptions(
      dataUsers.allUsers.edges.map(({node}) => ({
        label: `${node.firstName} ${node.lastName} - ${node.email}${
          node.npn ? ` (${node.npn})` : ''
        }`,
        value: node.id,
      }))
    )
  }, [dataUsers, valueDeb])

  useEffect(() => {
    if (!valueDeb) return
    gqlGetMembers({
      variables: {
        name: valueDeb,
        requireNpn: typeAssign === 'USER_TO',
      },
    })
  }, [gqlGetMembers, valueDeb, typeAssign])

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        {typeAssign === 'ASSIGN_TO' && <Modal.Title>Assign policy</Modal.Title>}
        {typeAssign === 'USER_TO' && <Modal.Title>Transfer policy</Modal.Title>}
      </Modal.Header>
      <Modal.Body>
        <Form id='formId' onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label>
              {typeAssign === 'ASSIGN_TO' && 'Select the user to assign this policy'}
              {typeAssign === 'USER_TO' && 'Select the owner'}
            </Form.Label>
            <Select
              isLoading={loadingUsers}
              loadingMessage={() => 'loading members'}
              placeholder='Search and select ...'
              options={options}
              inputValue={inputSelect}
              onInputChange={setInputSelect}
              onChange={(selectedOption) => {
                const userId = selectedOption?.value || 0
                console.log('Seleccionado:', userId)
                setAgent('' + parseId(userId))
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button size='sm' variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          size='sm'
          variant='primary'
          type='submit'
          form='formId'
          formAction='formId'
          disabled={!agentId || loading}
        >
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
